document.addEventListener("DOMContentLoaded", function () {
    const selects = document.querySelectorAll(".select:not(.select-custom)");
    selects?.forEach((el) => {
        const select = el.querySelector("select");
        const backdrop = el.querySelector(".backdrop");
        const button = el.querySelector('[role="combobox"]');
        const announcement = el.querySelector(".announcement");
        const dropdown = el.querySelector('[role="listbox"]');
        const options = el.querySelectorAll('[role="option"]');
        const selected = el.querySelector(".selected");

        const toggleDropdown = () => {
            dropdown.classList.toggle("active");
            button.setAttribute("aria-expanded", dropdown.classList.contains("active").toString());

            if (!dropdown.classList.contains("active")) {
                button.focus();
                // Clear any current focus when closing
                options.forEach((o) => o.classList.remove("current"));
            }
        };

        const handleKeyPress = (event) => {
            const { key } = event;
            if (key === "Tab") {
                if (dropdown.classList.contains("active")) toggleDropdown();
                return;
            }
            event.preventDefault();
            const openKeys = ["ArrowDown", "ArrowUp", "Enter", " "];

            if (!dropdown.classList.contains("active") && openKeys.includes(key)) {
                toggleDropdown();
                // Focus first option when opening with keyboard
                if (key === "ArrowDown" || key === "ArrowUp") {
                    focusOption(options[0]);
                }
            } else if (dropdown.classList.contains("active")) {
                const currentOption = Array.from(options).find((o) =>
                    o.classList.contains("current")
                );
                switch (key) {
                    case "Escape":
                        toggleDropdown();
                        break;
                    case "ArrowDown":
                        if (currentOption) {
                            focusOption(currentOption.nextElementSibling);
                        } else {
                            focusOption(options[0]);
                        }
                        break;
                    case "ArrowUp":
                        if (currentOption) {
                            focusOption(currentOption.previousElementSibling);
                        } else {
                            focusOption(options[options.length - 1]);
                        }
                        break;
                    case "Enter":
                    case " ":
                        if (currentOption) {
                            selectOptionByElement(currentOption);
                        }
                        break;
                    default:
                        // Handle alphanumeric key presses for mini-search
                        handleAlphanumericKeyPress(key);
                        break;
                }
            }
        };

        const focusOption = (option) => {
            if (!option) return;
            const optionLabel = option.querySelector(".label").textContent;

            option.classList.add("current");
            option.focus();

            // Scroll the current option into view
            option.scrollIntoView({
                block: "nearest",
            });

            options.forEach((o) => {
                if (o !== option) {
                    o.classList.remove("current");
                }
            });
            announceOption(`You're currently focused on ${optionLabel}`);
        };

        const selectOptionByElement = (option) => {
            const optionValue = option.getAttribute("data-value");
            const optionLabel = option.querySelector(".label").textContent;
            const isAlreadyActive = option.classList.contains("active");

            // If clicking the active option, clear selection (show all)
            if (isAlreadyActive) {
                options.forEach((o) => {
                    o.classList.remove("active");
                    o.setAttribute("aria-selected", "false");
                });
                selected.querySelectorAll(".tag")?.forEach((tag) => tag.remove());

                // Clear native select value
                Array.from(select.options).forEach((o) => {
                    o.selected = false;
                });

                const event = new Event("change", { bubbles: true });
                select.dispatchEvent(event);

                toggleDropdown();
                announceOption(`${optionLabel} cleared`);
                return;
            }

            // Clear previous active state
            options.forEach((o) => {
                o.classList.remove("active");
                o.setAttribute("aria-selected", "false");
            });
            selected.querySelectorAll(".tag")?.forEach((tag) => tag.remove());

            // Set the new active option
            option.classList.add("active");
            option.setAttribute("aria-selected", "true");

            const tag = document.createElement("span");
            tag.classList.add("tag");
            tag.textContent = optionLabel;
            selected.appendChild(tag);

            // Sync native select single value
            Array.from(select.options).forEach((o) => {
                o.selected = o.value === optionValue;
            });

            const event = new Event("change", { bubbles: true });
            select.dispatchEvent(event);

            toggleDropdown();
            announceOption(optionLabel);
        };

        const handleAlphanumericKeyPress = (key) => {
            const typedChar = key.toLowerCase();
            const matchingOptions = Array.from(options).filter((o) =>
                o.querySelector(".label").textContent.toLowerCase().startsWith(typedChar)
            );

            if (matchingOptions.length) {
                const currentIndex = matchingOptions.findIndex((o) =>
                    o.classList.contains("current")
                );
                const nextIndex = currentIndex + 1 >= matchingOptions.length ? 0 : currentIndex + 1;
                const option = Array.from(options).find((o) => o === matchingOptions[nextIndex]);
                focusOption(option);
            }
        };

        const announceOption = (text) => {
            announcement.textContent = text;
            announcement.setAttribute("aria-live", "assertive");
            setTimeout(() => {
                announcement.textContent = "";
                announcement.setAttribute("aria-live", "off");
            }, 1000);
        };

        button.addEventListener("keydown", handleKeyPress);
        button.addEventListener("click", toggleDropdown);
        backdrop.addEventListener("click", () => {
            if (dropdown.classList.contains("active")) {
                toggleDropdown();
            }
        });
        options.forEach((o) => o.addEventListener("click", () => selectOptionByElement(o)));

        const setPositionDropdown = (dropdown) => {
            const dropdownRect = dropdown.getBoundingClientRect();
            const offset = 16;

            if (dropdownRect.x < 0) {
                dropdown.style.setProperty("--offset", `${Math.abs(dropdownRect.x) + offset}px`);
            } else if (dropdownRect.x + dropdownRect.width + offset > window.innerWidth) {
                dropdown.style.setProperty(
                    "--offset",
                    `${window.innerWidth - (dropdownRect.x + dropdownRect.width + offset)}px`
                );
            }
        };

        setPositionDropdown(dropdown);
    });
});
